export default {
  state: {
    selectedList: {}
  },
  getters: {
    'lotHistory:selectedList': state => state.selectedList
  },
  actions: {
    lotHistorySelected ({ commit }, selectedList) {
      console.log('lotHistorySelected', selectedList)
      commit('setSelectedList', selectedList)
    }
  },
  mutations: {
    setSelectedList (state, payload) {
      state.selectedList = payload
    }
  }
}
